import React, { useState } from "react";
import MediaPlayer from './MediaPlayer';
import { Select } from 'antd';

type PlaylistType = {
    [key: string]: string;
};


const PlaylistObj: PlaylistType = {
    "Ramadan 1444H - Introduction au mois de Ramadan": "/output_00001/playlist.m3u8",
    "Ramadan 1444H - Lecture Juz' 1": "/output_00002/playlist.m3u8",
    "Ramadan 1444H - Lecture Juz' 2": "/output_00003/playlist.m3u8",
    "Ramadan 1444H - 1er Joumou'a - Lecture Sourate Al-Kahf": "/output_00004/playlist.m3u8",
    "Ramadan 1444H - Lecture Juz' 3": "/output_00005/playlist.m3u8",
    "Ramadan 1444H - Lecture Juz' 4": "/output_00006/playlist.m3u8",
    "Ramadan 1444H - Lecture Juz' 5": "/output_00007/playlist.m3u8",
    "Ramadan 1444H - Lecture Juz' 6": "/output_00008/playlist.m3u8",
    "Ramadan 1444H - Lecture Juz' 7": "/output_00009/playlist.m3u8",
    "Ramadan 1444H - Lecture Juz' 8": "/output_00010/playlist.m3u8",
}


const Options = Object.keys(PlaylistObj).map((k: string) => { return { value: k, label: k } })


const WrapperMediaPlayer = () => {
    const [currentTrack, setCurrentTrack] = useState<string>("Ramadan 1444H - Introduction au mois de Ramadan");

    const handleChange = (value: string) => {
        console.log(`selected ${value}`);
        setCurrentTrack(value);
    }

    return (
        <div>
            <Select
                defaultValue={currentTrack}
                style={{ width: 300 }}
                onChange={handleChange}
            >
                {Options.map((o: any) => {
                    return <Select.Option key={o.value} value={o.value}>{o.label}
                    </Select.Option>
                })}
            </Select>
            <MediaPlayer audioSrc={PlaylistObj[currentTrack]}  key={currentTrack}/>
        </div>
    );

}


export default WrapperMediaPlayer;